import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NCatalogUi } from '@df/catalog-ui/df-catalog-ui.config';
import { IListingSizeOption } from '@df/catalog-ui/listing/size/listing-size';
import { Client } from '@df/core/service/client';
import { AdvancedCommerceListingSizeComponentDef } from '@df/module-advanced-commerce';
import { GtmService } from '@df/module-gtm/gtm.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { Subscription } from 'rxjs';
@Component({
    selector: 'ac-listing-size',
    templateUrl: '../../../../catalog/ui/listing/size/listing-size.html',
    standalone: true,
    imports: [NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceListingSizeComponent extends AdvancedCommerceListingSizeComponentDef implements NListing.ISize {
    private gtmService = inject(GtmService);
    private client = inject(Client);
    private catalogUiOptions = inject(NCatalogUi.OPTIONS);
    private breakpointSub?: Subscription;
    /**
     * When size changes reset subscription
     */

    // fake input to make it work on old template without ac
    @Input()
    size = true;

    ngOnInit(): void {
        this.store.setListingSize(this.client.sizeId > 1 ? 4 : 2);
        this.breakpointSub = this.client.obs.breakpoint.subscribe(size => {
            if (
                !this.catalogUiOptions?.listing.category.size?.find(
                    option => option.size === this.store.listingCurrentSize() && option.onSize?.includes(size)
                )
            ) {
                this.store.setListingSize(this.client.sizeId > 1 ? 4 : 2);
            }
        });
    }

    ngOnDestroy(): void {
        this.breakpointSub?.unsubscribe();
    }

    private sendA4Event(): void {
        this.gtmService.sendEventGA4('plp_layout', { grid: this.store.listingCurrentSize() + '-col' });
    }
    get options() {
        return this.store.listingSize()?.options;
    }
    isSelected(option: NListing.ISizeOption | IListingSizeOption): boolean {
        return this.store.listingCurrentSize() === option.size;
    }
    setState(size: number): void {
        this.sendA4Event();
        this.store.setListingSize(size);
    }
}
